export function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const RAD = Math.PI / 180;

export function lerp(t, a, b) {
  return a * (1 - t) + b * t;
}

export function clamp(a, t, b) {
  return Math.max(a, Math.min(t, b));
}

export function norm(t, a, b) {
  return (t - a) / (b - a);
}

export function map(t, a0, b0, a1, b1) {
  return lerp(norm(t, a0, b0), a1, b1);
}

export function mix(__a, __b, __x) {
  return lerp(__x, __a, __b);
}

export function smoothstep(__x, __a, __b) {
  return lerp(__x * __x * (3.0 - 2.0 * __x), __a, __b);
}

export function distance(a, b) {
  let dx = a.x - b.x;
  let dy = a.y - b.y;
  return Math.sqrt(dx * dx + dy * dy);
}
// color

export function rgbToInts(rgb) {
  let cols = rgb.replace("rgb(", "").replace(")", "").split(",");
  cols = cols.map((v) => {
    return parseFloat(v.trim());
  });
  return cols;
}

export function rgbToNegative(rgb) {
  let cols = rgb.replace("rgb(", "").replace(")", "").split(",");
  cols = cols.map((v) => {
    return 0xff - parseFloat(v.trim());
  });
  return `rgb(${cols[0]}, ${cols[2]}, ${cols[2]} )`;
}

export function rgbToFloats(rgb) {
  let cols = rgbToInts(rgb).map((v) => {
    return v / 0xff;
  });
  return cols;
}
export function rgbToNegativeFloats(rgb) {
  let cols = rgbToInts(rgb).map((v) => {
    return 1 - v / 0xff;
  });
  return cols;
}

// https://stackoverflow.com/a/3943023
export function isDarkColor(rgb) {
  let cols = rgb.replace("rgb(", "").replace(")", "").split(",");
  cols = cols.map((v) => {
    v = parseFloat(v.trim());
    v = v / 255.0;
    if(v <= 0.03928) {
      return v / 12.92;
    } else {
      return Math.pow(((v + 0.055) / 1.055), 2.4);
    }
  });
  return (0.2126 * cols[0] + 0.7152 * cols[1] + 0.0722 * cols[2]) < 0.179;
}

export function containsVec2(poly, x, y) {
  var c = false,
    l = poly.length,
    j = l - 1;

  for (var i = -1; ++i < l; j = i) {
    ((poly[i].y <= y && y < poly[j].y) || (poly[j].y <= y && y < poly[i].y)) &&
      x <
        ((poly[j].x - poly[i].x) * (y - poly[i].y)) / (poly[j].y - poly[i].y) +
          poly[i].x &&
      (c = !c);
  }
  return c;
}
